import { ReactNode } from 'react';
import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { NakedUl } from '../../../naked/naked-ul.component';

const listFieldUlStyle = css`
  margin: ${theme.spacing(2, 0, 0)};
`;

export const ListFieldUl: React.FC<React.PropsWithChildren<{ children: ReactNode }>> = ({ children }) => {
  return <NakedUl className={listFieldUlStyle}>{children}</NakedUl>;
};
